import api, { transformRequest, transformResponse } from "services/api";

const portalConfigurationsAPI = api
  .enhanceEndpoints({
    addTagTypes: [
      "DebtorPortalConfigurations",
      "ClientPortalConfigurations",
      "PaymentPortalConfigurations",
    ],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getConsumerPortalConfigurations: build.query({
        query: () => ({
          url: "/api/v1/core/debtor-portal-configurations/",
          method: "POST",
        }),
        transformResponse: (response) => transformResponse(response),
        providesTags: (response) =>
          response?.results
            ? // successful query
              [
                ...response.results.map(({ id }) => ({ type: "DebtorPortalConfigurations", id })),
                { type: "DebtorPortalConfigurations", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'DebtorPortalConfigurations', id: 'LIST' }` is invalidated
              [{ type: "DebtorPortalConfigurations", id: "LIST" }],
      }),
      getClientPortalConfigurations: build.query({
        query: () => ({
          url: "/api/v1/core/creditor-portal-configurations/",
          method: "POST",
        }),
        transformResponse: (response) => transformResponse(response),
        providesTags: (response) =>
          response?.results
            ? // successful query
              [
                ...response.results.map(({ id }) => ({ type: "ClientPortalConfigurations", id })),
                { type: "ClientPortalConfigurations", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'ClientPortalConfigurations', id: 'LIST' }` is invalidated
              [{ type: "ClientPortalConfigurations", id: "LIST" }],
      }),
      getPaymentPortalConfigurations: build.query({
        query: () => ({
          url: "/api/v1/core/payment-portal-configurations/",
          method: "POST",
        }),
        transformResponse: (response) => transformResponse(response),
        providesTags: (response) =>
          response?.results
            ? // successful query
              [
                ...response.results.map(({ id }) => ({ type: "PaymentPortalConfigurations", id })),
                { type: "PaymentPortalConfigurations", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'PaymentPortalConfigurations', id: 'LIST' }` is invalidated
              [{ type: "PaymentPortalConfigurations", id: "LIST" }],
      }),
      updateDebtorPortalConfigurations: build.mutation({
        query: (data) => ({
          url: "/api/v1/core/debtor-portal-configurations/update/",
          method: "POST",
          body: transformRequest(data),
        }),
        invalidatesTags: ["DebtorPortalConfigurations"],
      }),
      updateClientPortalConfigurations: build.mutation({
        query: (data) => ({
          url: "/api/v1/core/creditor-portal-configurations/update/",
          method: "POST",
          body: transformRequest(data),
        }),
        invalidatesTags: ["ClientPortalConfigurations"],
      }),
      updatePaymentPortalConfigurations: build.mutation({
        query: (data) => ({
          url: "/api/v1/core/payment-portal-configurations/update/",
          method: "POST",
          body: transformRequest(data),
        }),
        invalidatesTags: ["PaymentPortalConfigurations"],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetConsumerPortalConfigurationsQuery,
  useGetClientPortalConfigurationsQuery,
  useGetPaymentPortalConfigurationsQuery,
  useUpdateDebtorPortalConfigurationsMutation,
  useUpdateClientPortalConfigurationsMutation,
  useUpdatePaymentPortalConfigurationsMutation,
} = portalConfigurationsAPI;
